import React from "react";
import LogoImage from "../../assets/images/IGt Logo.png";

export default function SidebarLogo() {
  return (
    <div className="flex items-center justify-center">
      <img 
        src={LogoImage} 
        alt="Company Logo" 
        className="object-cover"
      />
    </div>
  );
}
